import { warningTypeColorMap } from 'core/constants';
import { Price, WarningCell } from 'core/elements';
import { WarningType } from 'core/enums';
import { Color } from 'theme/enums';

interface IProps {
  cost: number;
  decimals?: number;
  fixedDecimals?: boolean;
  showWarning?: boolean;
  color?: Color;
  warningType?: WarningType;
  label?: string;
}

const StandardCost = ({
  cost,
  decimals,
  fixedDecimals = false,
  showWarning = false,
  color = null,
  warningType,
  label,
}: IProps) => {
  const getContentColor = () => {
    if (color) {
      return color;
    }

    return showWarning ? warningTypeColorMap?.[warningType] : null;
  };

  return (
    <WarningCell
      content={
        <Price
          amount={cost}
          labelColor={Color.NEUTRAL}
          color={getContentColor()}
          decimals={decimals}
          fixedDecimals={fixedDecimals}
          label={label}
        />
      }
      showWarning={showWarning}
      type={warningType}
    />
  );
};

export default StandardCost;
